import script from "./MoleculeCookies.vue?vue&type=script&lang=ts&setup=true"
export * from "./MoleculeCookies.vue?vue&type=script&lang=ts&setup=true"

import "./MoleculeCookies.vue?vue&type=style&index=0&id=3c531fe6&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c531fe6"]])

export default __exports__